export enum PermissionKind {
  EmptyMask = "EmptyMask",
  ViewListItems = "ViewListItems",
  AddListItems = "AddListItems",
  EditListItems = "EditListItems",
  DeleteListItems = "DeleteListItems",
  ApproveItems = "ApproveItems",
  OpenItems = "OpenItems",
  ViewVersions = "ViewVersions",
  DeleteVersions = "DeleteVersions",
  CancelCheckout = "CancelCheckout",
  ManagePersonalViews = "ManagePersonalViews",
  ManageLists = "ManageLists",
  ViewFormPages = "ViewFormPages",
  AnonymousSearchAccessList = "AnonymousSearchAccessList",
  Open = "Open",
  ViewPages = "ViewPages",
  AddAndCustomizePages = "AddAndCustomizePages",
  ApplyThemeAndBorder = "ApplyThemeAndBorder",
  ApplyStyleSheets = "ApplyStyleSheets",
  ViewUsageData = "ViewUsageData",
  CreateSSCSite = "CreateSSCSite",
  ManageSubwebs = "ManageSubwebs",
  CreateGroups = "CreateGroups",
  ManagePermissions = "ManagePermissions",
  BrowseDirectories = "BrowseDirectories",
  BrowseUserInfo = "BrowseUserInfo",
  AddDelPrivateWebParts = "AddDelPrivateWebParts",
  UpdatePersonalWebParts = "UpdatePersonalWebParts",
  ManageWeb = "ManageWeb",  
  AnonymousSearchAccessWebLists = "AnonymousSearchAccessWebLists",
  UseClientIntegration = "UseClientIntegration",
  UseRemoteAPIs = "UseRemoteAPIs",
  ManageAlerts = "ManageAlerts",
  CreateAlerts = "CreateAlerts",
  EditMyUserInfo = "EditMyUserInfo",
  EnumeratePermissions = "EnumeratePermissions",
  FullMask = "FullMask"
}

export const PermissionKindNames = new Map<string, string>([
  [PermissionKind.EmptyMask, "Empty Mask"],
  [PermissionKind.ViewListItems, "View List Items"],
  [PermissionKind.AddListItems, "Add List Items"],
  [PermissionKind.EditListItems, "Edit List Items"],
  [PermissionKind.DeleteListItems, "Delete List Items"],
  [PermissionKind.ApproveItems, "Approve Items"],
  [PermissionKind.OpenItems, "Open Items"],
  [PermissionKind.ViewVersions, "View Versions"],
  [PermissionKind.DeleteVersions, "Delete Versions"],
  [PermissionKind.CancelCheckout, "Cancel Checkout"],
  [PermissionKind.ManagePersonalViews, "Manage Personal Views"],
  [PermissionKind.ManageLists, "Manage Lists"],
  [PermissionKind.ViewFormPages, "View Form Pages"],
  [PermissionKind.AnonymousSearchAccessList, "Anonymous Search Access List"],
  [PermissionKind.Open, "Open"],
  [PermissionKind.ViewPages, "View Pages"],
  [PermissionKind.AddAndCustomizePages, "Add and Customize Pages"],
  [PermissionKind.ApplyThemeAndBorder, "Apply Themes and Borders"],
  [PermissionKind.ApplyStyleSheets, "Apply Style Sheets"],
  [PermissionKind.ViewUsageData, "View Usage Data"],
  [PermissionKind.CreateSSCSite, "Use Self-Service Site Creation"],
  [PermissionKind.ManageSubwebs, "Manage Sub-webs"],
  [PermissionKind.CreateGroups, "Create Groups"],
  [PermissionKind.ManagePermissions, "Manage Permissions"],
  [PermissionKind.BrowseDirectories, "Browse Directories"],
  [PermissionKind.BrowseUserInfo, "Browse User Information "],
  [PermissionKind.AddDelPrivateWebParts, "Add/Remove Personal Web Parts"],
  [PermissionKind.UpdatePersonalWebParts, "Update Personal Web Parts"],
  [PermissionKind.ManageWeb, "Create Subsites"],
  [PermissionKind.AnonymousSearchAccessWebLists, "Anonymous Search Access Web Lists"],
  [PermissionKind.UseClientIntegration, "Use Client Integration Features"],
  [PermissionKind.UseRemoteAPIs, "Use Remote Interfaces"],
  [PermissionKind.ManageAlerts, "Manage Alerts"],
  [PermissionKind.CreateAlerts, "Create Alerts"],
  [PermissionKind.EditMyUserInfo, "Edit Personal User Information"],
  [PermissionKind.EnumeratePermissions, "Enumerate Permissions"],
  [PermissionKind.FullMask, "Full Mask"]
]);
